// #################################################################################################### DomLoaded
document.addEventListener("DOMContentLoaded", function() {
  console.log("DomLoaded");
});